import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private signalSubject = new BehaviorSubject<boolean>(false);
  signal$ = this.signalSubject.asObservable();

  private menuSubject = new BehaviorSubject<string>('');
  menu$ = this.menuSubject.asObservable();

  setSignal(value: boolean): void {
    this.signalSubject.next(value);
  }

  selectedMenu(menu: string): void {
    this.menuSubject.next(menu);
  }
}
